<template>
  <div class="the-sidebar d-flex justify-content-between flex-column">
    <div class="file-nav">
      <div style="cursor: pointer" class="d-flex justify-content-start align-items-center">
        <img src="@/assets/Logo-Group.svg" width="18" height="18px" />&nbsp;&nbsp;
        <span>
          <strong>Fexspace Drive</strong>
        </span>
      </div>
      <template v-if="$store.getters.canCreateFiles">
        <div class="mt-2 mb-2">
          <span class="upload-btn" @click="upload">
            <img src="@/assets/upload-icon.svg" />&nbsp;&nbsp;
            <span>Upload</span>
          </span>
        </div>
      </template>
      <template v-else>
        <template v-if="$store.getters.canCreateFileInGroup">
          <div class="mt-2 mb-2">
            <span class="upload-btn" @click="upload">
              <img src="@/assets/upload-icon.svg" />&nbsp;&nbsp;
              <span>Upload</span>
            </span>
          </div>
        </template>
      </template>
      <div class="list mt-2" :class="{ 'personal-scroll': $store.getters.PERSONAL_SCROLL }">
        <ul class="personal">
          <li @click="back">
            <img src="@/assets/hard-drive 1.svg" width="18px" height="18px" />&nbsp;&nbsp;&nbsp;
            <span>Home</span>
          </li>
          <li class="d-flex flex-column">
            <div class="w-100 d-flex justify-content-between align-items-center" @click="show_files">
              <span class="d-inline-flex justify-content-start align-items-center">
                <img src="@/assets/Folder-Icon.svg" width="18px" height="18px" />&nbsp;&nbsp;&nbsp;
                <span>Files</span>
              </span>
              <span style="margin-right: 5px">
                <img src="@/assets/dropdown-arrow.svg" :class="{ 'rotate-90': files }" />
              </span>
            </div>
            <div class="w-100 ml-2" v-if="files">
              <ul class="personal-default-folder">
                <li v-for="(folder, index) in $store.getters.GET_DEFAULT_FOLDER" :key="index"
                  @click="browse(folder, folder.dir)">
                  <div dropzone @drop="getData(folder, $event)" @dragenter="handleDragEnter(folder, $event)">
                    <img src="@/assets/personal-folder-icon.svg" width="18px" height="18px" />
                    &nbsp;{{ folder.dir }}
                  </div>
                  <div class="drag-area" v-show="showDrop">
                    Drop files here
                  </div>
                </li>
              </ul>
            </div>
          </li>
          <li @click="myfav">
            <img src="@/assets/star.svg" width="18px" height="18px" />
            &nbsp;&nbsp;&nbsp;Favourites
          </li>
          <li @click="sharedfiles">
            <img src="@/assets/shared-folder-icon.svg" width="18px" height="18px" />
            &nbsp;&nbsp;&nbsp;Shared Files
          </li>
          <li @click="sharedwithme">
            <img src="@/assets/shared-folder-icon.svg" width="18px" height="18px" />
            &nbsp;&nbsp;&nbsp;Shared With Me
            <span class="share-notice" v-if="$store.getters.SHARED_WITH_ME_COUNT > 0">{{
              $store.getters.SHARED_WITH_ME_COUNT }}</span>
          </li>
          <li @click="browse_project">
            <img src="@/assets/public-folder-icon.svg" width="18px" height="18px" />
            &nbsp;&nbsp;&nbsp;Project Folder
          </li>
          <li @click="browse_group">
            <img src="@/assets/group-folder-icon.svg" width="18px" height="18px" />
            &nbsp;&nbsp;&nbsp;Group Folder
          </li>
          <li @click="browse_public($store.getters.PUBLIC_FOLDER_ID)">
            <img src="@/assets/public-folder-icon-2.svg" width="18px" height="18px" />
            &nbsp;&nbsp;&nbsp;Public
          </li>
          <li @click="browse_trash">
            <span><img src="@/assets/dashicons_trash.svg" width="18px" height="18px" /></span>
            &nbsp;&nbsp;&nbsp;Trash
          </li>
        </ul>
      </div>
    </div>
    <div class="statistics">
      <div class="d-flex flex-column justify-content-center align-items-center">
        <span class="d-flex flex-column justify-content-center align-items-center">
          <img src="@/assets/bi_cloud-check-fill.svg" width="40px" height="auto" />
          <span>Storage (10% full)</span>
        </span>
        <span class="usage-bar">
          <template v-if="
            Math.ceil(
              ($store.getters.GET_TOTAL_USED_SPACE /
                $store.getters.GET_TOTAL_SPACE) *
              100
            ) == 100 ||
            Math.ceil(
              ($store.getters.GET_TOTAL_USED_SPACE /
                $store.getters.GET_TOTAL_SPACE) *
              100
            ) > 100
          ">
            <span class="bar-exceed" :style="{
              width: 100 + '%',
              display: 'block',
              color: '#FC6D6C !important',
            }"></span>
          </template>
          <template v-if="
            Math.ceil(
              ($store.getters.GET_TOTAL_USED_SPACE /
                $store.getters.GET_TOTAL_SPACE) *
              100
            ) > 80 ||
            Math.ceil(
              ($store.getters.GET_TOTAL_USED_SPACE /
                $store.getters.GET_TOTAL_SPACE) *
              100
            ) == 80
          ">
            <span class="bar-exceed" :style="{
              width:
                ($store.getters.GET_TOTAL_USED_SPACE /
                  $store.getters.GET_TOTAL_SPACE) *
                100 +
                '%',
              display: 'block',
              color: '#FC6D6C !important',
            }"></span>
          </template>
          <template v-if="
            Math.ceil(
              ($store.getters.GET_TOTAL_USED_SPACE /
                $store.getters.GET_TOTAL_SPACE) *
              100
            ) < 80
          ">
            <span class="bar" :style="{
              width:
                ($store.getters.GET_TOTAL_USED_SPACE /
                  $store.getters.GET_TOTAL_SPACE) *
                100 +
                '%',
              display: 'block',
            }"></span>
          </template>
        </span>
        <span class="stat-data">{{ $sizeFormat($store.getters.GET_TOTAL_USED_SPACE) }} of
          <span class="" v-if="$store.getters.GET_TOTAL_SPACE === 'Unlimited'">Inifinity</span><span
            v-if="$store.getters.GET_TOTAL_SPACE !== 'Unlimited'">{{
              $sizeFormat($store.getters.GET_TOTAL_SPACE)
            }}</span>
          Used</span>
      </div>
    </div>
  </div>
</template>
<style scoped>
.rotate-90 {
  transform: rotate(-180deg);
}

.the-sidebar {
  padding-bottom: 1em;
  padding-top: 1em;
  position: relative;
  height: calc(100%);
}

.the-sidebar .file-nav {
  z-index: 10;
  background: #fff;
  /*max-height: calc(100% - 3rem); */
  overflow: hidden;
  padding-bottom: 0.875rem;
}

.statistics>div {
  height: 100%;
}

.statistics {
  z-index: 1;
  background: #f3f5f7;
  position: absolute;
  bottom: 14px;
  width: 100%;
  height: 110px;
  border-radius: 6px;
  padding: 16px 10px;
  color: #111111 !important;
  font-size: 14px !important;
}

.usage-bar {
  border-radius: 50px;
  background: #d9ecfa !important;
  height: 6px !important;
  margin-top: 0.5em;
  margin-bottom: 5px !important;
}

.stat-data {
  margin-bottom: 0;
}

.upload-btn {
  background: #3f96d1;
  height: 44px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  border-radius: 5px;
  cursor: pointer;
  color: #fff;
  font-size: 14px;
}

.personal {
  margin-left: 12px;
}

.personal li {
  cursor: pointer;
  display: flex;
  justify-content: start !important;
  align-items: center !important;
  font-size: 14px !important;
  font-family: "Inter" !important;
  color: #4b5458 !important;
}

.personal>li {
  cursor: pointer;
  margin-bottom: 10px !important;
}

.personal div ul li {
  margin-bottom: 10px !important;
}

.personal div ul {
  margin-top: 10px !important;
}
</style>
<script>
import { mapMutations } from "vuex";
import moment from "moment";
import cookies from "@/services/cookies";

export default {
  data() {
    return {
      files: true,
      showDrop: false
    };
  },
  methods: {
    setShowDrop(drop) {
      this.showDrop = drop;
    },
    handleDragEnter(folder, $event) {
      let file = JSON.parse(localStorage.getItem('dragstart'))
      let index = JSON.parse(localStorage.getItem('dragstartindex'))

      if (file.group == 'GROUP' || file.group == 'PROJECT' || file.group == 'PUBLIC') {
        // console.log(file)
        this.$parent.dragError(file.dir)
        return
      }


      if (this.$store.getters.ISTRIAL) {
        if (!this.$store.getters.TRIAL_STATUS) {
          if (this.$store.getters.ISSTAFF) {
            this.$parent.notifyexpiration(
              "Your trial period has expired. <br/>Please contact your admin"
            );
            return;
          } else {
            this.$parent.notifyexpiration(
              'Your trial period has expired. <a href="/payments-billing">Payments & Billing</a>'
            );
            return;
          }
        }
      } else {
        if (!this.$store.getters.PLAN_STATUS) {
          if (this.$store.getters.ISSTAFF) {
            this.$parent.notifyexpiration(
              "Your trial period has expired.. <br/>Please contact your admin"
            );
            return;
          } else {
            this.$parent.notifyexpiration(
              'Your trial period has expired.. <a href="/payments-billing">Payments & Billing</a>'
            );
            return;
          }
        }
      }
      this.$parent.dragmoveprompt(folder, file, index);
      $event.preventDefault();
      // this.setShowDrop(true);
    },
    handleDragLeave(folder, $event) {
      $event.preventDefault();
      // this.setShowDrop(false);
    },
    getData(folder, e) {
      console.log(e)
      // console.log(JSON.parse(localStorage.getItem('dragstart')))
      // console.log(JSON.parse(localStorage.getItem('dragstartindex')))
      let index = JSON.parse(localStorage.getItem('dragstartindex'))
      e.preventDefault();
      this.setShowDrop(false);

      if (this.$store.getters.ISTRIAL) {
        if (!this.$store.getters.TRIAL_STATUS) {
          if (this.$store.getters.ISSTAFF) {
            this.$parent.notifyexpiration(
              "Your trial period has expired. <br/>Please contact your admin"
            );
            return;
          } else {
            this.$parent.notifyexpiration(
              'Your trial period has expired. <a href="/payments-billing">Payments & Billing</a>'
            );
            return;
          }
        }
      } else {
        if (!this.$store.getters.PLAN_STATUS) {
          if (this.$store.getters.ISSTAFF) {
            this.$parent.notifyexpiration(
              "Your trial period has expired.. <br/>Please contact your admin"
            );
            return;
          } else {
            this.$parent.notifyexpiration(
              'Your trial period has expired.. <a href="/payments-billing">Payments & Billing</a>'
            );
            return;
          }
        }
      }
      this.$parent.moveto(index);

      if (file == null) {
        // this.$parent.drag_upload(
        //   e.dataTransfer.files,
        //   localStorage.getItem("current_directory_id")
        // );
      } else {
        // if (file.is_dir) {
        //   this.$parent.drag_upload(e.dataTransfer.files, file.id);
        // } else {
        //   this.$parent.drag_upload(
        //     e.dataTransfer.files,
        //     localStorage.getItem("current_directory_id")
        //   );
        // }
      }
    },
    upload_trigger() {
      this.$parent.upload();
    },
    upload() {
      this.$parent.showbrowseuploadfolder("sidebar");
      this.$emit("toggleFileNav");
    },
    show_files() {
      this.files = !this.files;
    },
    days_left(time) {
      let cur = moment(moment.now());
      let foundtime = moment(time);

      let days = cur.diff(foundtime, "days");
      return 30 - days;
    },
    hasExpired(time) {
      let duration = 30 * 24 * 60 * 60;
      let cur = moment(moment.now());
      let foundtime = moment(time);

      let seconds = cur.diff(foundtime, "seconds");
      return duration === seconds || seconds > duration;
    },
    ...mapMutations([
      "SET_FILE_ACTION",
      "REMOVE_FILE_ACTION",
      "SET_DIRECTORY_CHILDREN",
      "TOGGLE_FILE_INFO",
      "SORT_DIRECTORY_CHILDREN",
      "SORT_STORED_DIRECTORY_CHILDREN",
      "SET_STORED_DIRECTORY_CHILDREN",
      "SET_FILE_INFO_DATA",
      "SET_CURRENT_FILE_ID",
      "SET_CURRENT_DIRECTORY",
      "SET_PATH",
      "HIDE_FILE_INFO",
      "SET_SELECT_ALL",
      "EMPTY_FILES_INDEX",
      "SET_SELECT_ALL",
      "SET_DB",
      "UPDATE_SHARED_WITH_ME_COUNT",
      "SET_GROUP_CREATE_MODE",
      "SET_CREATE_RIGHT",
      "SET_DB",
      "SET_CAN_CREATE",
      "SET_VIEW_TYPE",
    ]),
    logincall() {
      this.$parent.logincall();
    },
    back() {
      this.SET_DB("filesystem");
      this.SET_CURRENT_DIRECTORY("Home");
      this.$parent.back();
    },
    myfav() {
      this.$emit("toggleFileNav");
      this.HIDE_FILE_INFO();
      this.SET_FILE_ACTION("");
      this.SET_SELECT_ALL(false);
      this.EMPTY_FILES_INDEX();

      this.SET_DB("favourite");

      let data = {
        token: cookies.getCookie("token"),
      };

      let that = this;

      this.$socket.emit("myfav", data, function (data) {
        if (data.data === true) {
          localStorage.setItem("current_directory_id", "");
          localStorage.setItem("current_directory", "My Favourite");
          localStorage.setItem("db", "favourite");
          that.SET_DIRECTORY_CHILDREN(data.directory_children);
          that.SET_STORED_DIRECTORY_CHILDREN(data.directory_children);
          that.SET_CURRENT_DIRECTORY("My Favourite");
          that.SET_PATH(data.dir_path);
          that.SORT_DIRECTORY_CHILDREN();
        }

        if (data.data === false) {
          that.logincall();
          that.$router.push('/login')
        }
      });
    },
    browse(dir, folder) {
      this.$emit("toggleFileNav");
      let data = {
        token: cookies.getCookie("token"),
        id: dir.id,
      };

      let that = this;

      let path = "";

      this.HIDE_FILE_INFO();
      this.SET_FILE_ACTION("");
      this.SET_SELECT_ALL(false);
      this.EMPTY_FILES_INDEX();

      if (folder === "Documents") {
        path = "get-documents";
      }

      if (folder === "Photos") {
        path = "get-photos";
      }

      if (folder === "Videos") {
        path = "get-videos";
      }

      if (folder === "Music") {
        path = "get-music";
      }

      this.$socket.emit(path, data, function (data) {
        if (data.data === true) {
          localStorage.setItem("current_directory_id", dir.id);
          localStorage.setItem("current_directory", dir.dir);
          localStorage.setItem("db", dir.db);
          sessionStorage.setItem("filepath", path);
          that.SET_DB(dir.db);
          that.SET_DIRECTORY_CHILDREN(data.directory_children);
          that.SET_STORED_DIRECTORY_CHILDREN(data.directory_children);
          that.SET_CURRENT_DIRECTORY(folder);
          that.SET_PATH(data.dir_path);
          that.SORT_DIRECTORY_CHILDREN();
        }

        if (data.data === false) {
          that.logincall();
          that.$router.push('/login')
        }
      });
    },
    browse_public(id) {
      this.$emit("toggleFileNav");
      let data = {
        token: cookies.getCookie("token"),
      };

      this.SET_FILE_ACTION("");
      this.HIDE_FILE_INFO();
      this.SET_SELECT_ALL(false);
      this.EMPTY_FILES_INDEX();

      let that = this;

      this.$socket.emit("browse-public", data, function (data) {
        if (data.data === true) {
          localStorage.setItem("current_directory_id", id);
          localStorage.setItem("current_directory", "Public");
          localStorage.setItem("db", "public");
          that.SET_DB("public");
          that.SET_DIRECTORY_CHILDREN(data.directory_children);
          that.SET_STORED_DIRECTORY_CHILDREN(data.directory_children);
          that.SET_CURRENT_DIRECTORY("Public");
          that.SET_PATH(data.dir_path);
          that.SORT_DIRECTORY_CHILDREN();
        }

        if (data.data === false) {
          that.logincall();
          that.$router.push('/login')
        }
      });
    },
    browse_trash() {
      this.$emit("toggleFileNav");
      let data = {
        token: cookies.getCookie("token"),
      };

      this.SET_FILE_ACTION("");
      this.HIDE_FILE_INFO();
      this.SET_SELECT_ALL(false);
      this.EMPTY_FILES_INDEX();
      this.SET_SELECT_ALL(false);

      let that = this;

      this.$socket.emit("get-trash-files", data, function (data) {
        if (data.data === true) {
          localStorage.setItem("current_directory_id", "");
          localStorage.setItem("current_directory", "Trash");
          localStorage.setItem("db", "trash");
          that.SET_DB("trash");
          that.SET_DIRECTORY_CHILDREN(data.directory_children);
          that.SET_STORED_DIRECTORY_CHILDREN(data.directory_children);
          that.SET_CURRENT_DIRECTORY("Trash");
          that.SET_PATH(data.dir_path);
          that.SORT_DIRECTORY_CHILDREN();
        }

        if (data.data === false) {
          that.logincall();
          that.$router.push('/login')
        }
      });
    },
    sharedfiles() {
      this.$emit("toggleFileNav");
      let data = {
        token: cookies.getCookie("token"),
      };

      this.SET_FILE_ACTION("");
      this.HIDE_FILE_INFO();
      this.SET_SELECT_ALL(false);
      this.EMPTY_FILES_INDEX();

      sessionStorage.removeItem("filepath");

      let that = this;

      this.$socket.emit("get-shared-files", data, function (data) {
        if (data.data === true) {
          localStorage.setItem("current_directory_id", "");
          localStorage.setItem("current_directory", "Shared Files");
          localStorage.setItem("db", "sharedfiles");
          that.SET_DB("sharedfiles");
          that.SET_DIRECTORY_CHILDREN(data.directory_children);
          that.SET_STORED_DIRECTORY_CHILDREN(data.directory_children);
          that.SET_CURRENT_DIRECTORY("Shared Files");
          that.SET_PATH(data.dir_path);
          that.SORT_DIRECTORY_CHILDREN();
        }

        if (data.data === false) {
          that.logincall();
          that.$router.push('/login')
        }
      });
    },
    browse_group() {
      this.$emit("toggleFileNav");
      let data = {
        token: cookies.getCookie("token"),
        db: "group",
        current_directory_id: sessionStorage.getItem("gi"),
      };

      this.SET_FILE_ACTION("");
      this.HIDE_FILE_INFO();
      this.SET_SELECT_ALL(false);
      this.EMPTY_FILES_INDEX();

      let that = this;

      sessionStorage.setItem("is_group", true);
      sessionStorage.setItem("create_mode", true);
      this.SET_GROUP_CREATE_MODE(sessionStorage.getItem("create_mode"));

      this.SET_CREATE_RIGHT(false);
      this.SET_DB(sessionStorage.getItem("group"));
      this.SET_CAN_CREATE(false);

      sessionStorage.setItem("create", false);

      this.$socket.emit("browse", data, function (data) {
        if (data.data === true) {
          localStorage.setItem(
            "current_directory_id",
            sessionStorage.getItem("gi")
          );
          localStorage.setItem("current_directory", "Group Folder");
          localStorage.setItem("db", "group");
          that.SET_DB("group");
          that.SET_DIRECTORY_CHILDREN(data.directory_children);
          that.SET_STORED_DIRECTORY_CHILDREN(data.directory_children);
          that.SET_CURRENT_DIRECTORY("Project Folder");
          that.SET_PATH(data.dir_path);
          that.SORT_DIRECTORY_CHILDREN();
        }

        if (data.data === false) {
          that.logincall();
          that.$router.push('/login')
        }
      });
    },
    browse_project() {
      this.$emit("toggleFileNav");
      let data = {
        token: cookies.getCookie("token"),
        db: "group",
        current_directory_id: sessionStorage.getItem("pi"),
      };

      this.SET_FILE_ACTION("");
      this.HIDE_FILE_INFO();
      this.SET_SELECT_ALL(false);
      this.EMPTY_FILES_INDEX();

      let that = this;

      sessionStorage.setItem("is_group", true);
      sessionStorage.setItem("create_mode", false);
      this.SET_GROUP_CREATE_MODE(sessionStorage.getItem("create_mode"));

      this.SET_CREATE_RIGHT(false);
      this.SET_DB(sessionStorage.getItem("group"));
      this.SET_CAN_CREATE(false);

      sessionStorage.setItem("create", false);

      this.$socket.emit("browse", data, function (data) {
        if (data.data === true) {
          localStorage.setItem(
            "current_directory_id",
            sessionStorage.getItem("pi")
          );
          localStorage.setItem("current_directory", "Project Folder");
          localStorage.setItem("db", "group");
          that.SET_DB("group");
          that.SET_DIRECTORY_CHILDREN(data.directory_children);
          that.SET_STORED_DIRECTORY_CHILDREN(data.directory_children);
          that.SET_CURRENT_DIRECTORY("Project Folder");
          that.SET_PATH(data.dir_path);
          that.SORT_DIRECTORY_CHILDREN();
        }

        if (data.data === false) {
          that.logincall();
          that.$router.push('/login')
        }
      });
    },
    sharedwithme() {
      this.SET_VIEW_TYPE("list");
      this.$emit("toggleFileNav");
      let data = {
        token: cookies.getCookie("token"),
      };

      this.SET_FILE_ACTION("");
      this.HIDE_FILE_INFO();
      this.SET_SELECT_ALL(false);
      this.EMPTY_FILES_INDEX();

      let that = this;

      this.$socket.emit("get-shared-with", data, function (data) {
        if (data.data === true) {
          localStorage.setItem("current_directory_id", "");
          localStorage.setItem("current_directory", "Shared With Me");
          localStorage.setItem("db", "sharedwithme");
          that.SET_DB("sharedwithme");

          that.SET_DIRECTORY_CHILDREN(data.directory_children);
          that.SET_STORED_DIRECTORY_CHILDREN(data.directory_children);
          that.SET_CURRENT_DIRECTORY("Shared With Me");
          that.SET_PATH(data.dir_path);
          that.SORT_DIRECTORY_CHILDREN();
          that.UPDATE_SHARED_WITH_ME_COUNT(0);
        }

        if (data.data === false) {
          that.logincall();
          that.$router.push('/login')
        }
      });
    },
  },
  mounted() {
    let data = {
      token: cookies.getCookie("token"),
    };

    let that = this;
    this.$socket.emit("shared-with-me-viewed", data, function (data) {
      if (data.data == true) {
        let count = data.folders.map((s) => {
          return s.is_viewed == false;
        });

        that.UPDATE_SHARED_WITH_ME_COUNT(count.length);
      }
    });
  },
};
</script>
